import axios from "axios";

export default {
  namespaced: true,
  actions: {
    getPendpendingPolls({ commit }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/marketing/poll/pending`,
        method: "GET",
      }).then(response => {
        commit("setPendingPolls", response.data);
        return response;
      });
    },
    retrieveGlobalPoll(_, identifier) {
      return axios({
        url: `${process.env.VUE_APP_URL}/marketing/poll/${identifier}`,
        method: "GET",
      });
    },
    answerPoll(_, {identifier, poll}) {
      return axios({
        url: `${process.env.VUE_APP_URL}/marketing/poll/${identifier}/answer`,
        method: "POST",
        data: poll
      });
    },
  },
  state: {
    pendingPolls: [],
  },
  mutations: {
    setPendingPolls(state, payload) {
      state.pendingPolls = payload;
    },
  },
  getters: {
    pendingPolls: state => {
      return state.pendingPolls;
    },
  },
};
